import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import groupBy from 'scaleflow/utils/group-by';
import numberSort from 'scaleflow/utils/numberSort';

export default class RoiInitiativesTableIndexComponent extends Component {
  @service intl;
  @service betaToggle;
  @service initiativeSlideover;
  get groupedInitiatives() {
    const noneLabel = this.intl.t('dictionary.none');
    const initiatives = this.args.initiatives.toSorted((a, b) =>
      numberSort(+a.bon_investment, +b.bon_investment),
    );
    const grouped = groupBy(initiatives, (initiative) => {
      if (initiative.source) return initiative.sourceLabel;
      else return noneLabel;
    });
    const orderedKeys = this.betaToggle.sourceOptions
      .map((item) => item.label)
      .reduce((acc, key) => {
        acc[key] = [];
        return acc;
      }, {});

    Object.entries(grouped).forEach(([key, value]) => {
      orderedKeys[key] = value;
    });
    if (grouped[noneLabel]) orderedKeys[noneLabel] = grouped[noneLabel];

    return orderedKeys;
  }

  @action
  openPopover(initiative_id) {
    this.initiativeSlideover.open(initiative_id);
  }
}
